__turbopack_context__.v({
  "bgImage": "styles-module-scss-module__NyHv2q__bgImage",
  "container": "styles-module-scss-module__NyHv2q__container",
  "containerDarkMode": "styles-module-scss-module__NyHv2q__containerDarkMode",
  "pinkBg": "styles-module-scss-module__NyHv2q__pinkBg",
  "root": "styles-module-scss-module__NyHv2q__root",
  "text": "styles-module-scss-module__NyHv2q__text",
  "title": "styles-module-scss-module__NyHv2q__title",
});
